module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Dish-d9797b4bff08ce59168e37261a1cadde.svg";